/** @format */

import {useIsSpecialistQuery} from 'graphql/operations/queries/isSpecialist/__generated__';

/**
 * Специалист (сотрудник) — это sub-аккаунт владельца, приглашённый по email.
 * У такого пользователя в currentUser заполнен parentUser (владелец, выдавший доступ).
 * У самого владельца parentUser отсутствует.
 */
export const useIsSpecialist = () => {
  const {data, loading, error} = useIsSpecialistQuery();

  return {
    loading,
    error,
    isSpecialist: Boolean(data?.currentUser?.parentUser),
  };
};
